import { NgModule } from '@angular/core';
import { FileManagementComponent } from './file-management.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BrowserModule } from '@angular/platform-browser';
import { SidebarModule } from 'ng-sidebar';
import { FileUploadModule } from 'ng2-file-upload';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DxAutocompleteModule } from 'devextreme-angular';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileSummaryComponent } from './file-summary/file-summary.component';
import { DiscussForumComponent } from './discuss-forum/discuss-forum.component';

@NgModule({
  declarations: [FileManagementComponent, FileUploadComponent, FileSummaryComponent, DiscussForumComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    NgbModule,
    FormsModule,
    FileUploadModule,
    ReactiveFormsModule,
    DxAutocompleteModule,
    SidebarModule.forRoot(),
    AccordionModule.forRoot()
  ],
  exports: [FileManagementComponent, FileUploadComponent, DiscussForumComponent, FileSummaryComponent]
})
export class FileManagementModule { }
